import Reveal from "@/components/Reveal";

const PRINCIPLES = [
  {
    tag: "01",
    title: "Scoped to Your Asset",
    desc: "Every engagement is shaped around your molecule, indication, patient segment, geography, and lifecycle stage.",
  },
  {
    tag: "02",
    title: "AI-Enabled. Expert-Validated.",
    desc: "AI helps capture and structure patient voice. Senior HEOR and patient evidence experts validate interpretation and recommendations.",
  },
  {
    tag: "03",
    title: "Output-Defined",
    desc: "Expected outputs are agreed upfront and aligned to the engagement objective.",
  },
  {
    tag: "04",
    title: "Cross-Functional by Design",
    desc: "Patient themes are translated into recommendations for the teams responsible for action.",
  },
];

export default function EngagementModel() {
  return (
    <section className="bg-ink-1 relative" data-testid="engagement-model-section">
      <div className="container-edge py-24 lg:py-32">
        <Reveal>
          <div className="eyebrow">How we engage</div>
          <h2 className="font-serif font-normal text-3xl md:text-5xl lg:text-[3.75rem] tracking-tight mt-4 text-parchment-bright max-w-4xl leading-[1.05]">
            A services engagement. Not a software subscription.
          </h2>
          <p className="mt-7 max-w-3xl text-parchment/85 text-lg leading-relaxed">
            Clients do not buy seats, licenses, or platform access.
          </p>
          <p className="mt-4 max-w-3xl text-parchment/75 text-lg leading-relaxed">
            Each engagement is scoped around an asset, indication, lifecycle stage, geography, and evidence need. The workspace supports delivery, collaboration, and review — it is not a separately priced software product.
          </p>
        </Reveal>

        <Reveal className="mt-14">
          <div className="eyebrow">Engagement principles</div>
        </Reveal>

        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/[0.08] border border-white/[0.08]">
          {PRINCIPLES.map((p, i) => (
            <Reveal
              key={p.tag}
              delay={i * 80}
              className="bg-ink-2 p-7 lg:p-8 card-dark-hover flex flex-col"
              data-testid={`engagement-principle-${p.tag}`}
            >
              <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-rust mb-4">
                Principle {p.tag}
              </div>
              <h3 className="font-serif text-[1.45rem] text-parchment-bright leading-snug min-h-[3.5rem]">
                {p.title}
              </h3>
              <p className="mt-4 text-[14px] text-parchment/70 leading-relaxed flex-1">{p.desc}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
